import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { ChallengeEventPage } from '~/components/Challenge/Event/ChallengeEventPage';
import { ChallengeGuidePage } from '~/components/Challenge/Guide/ChallengeGuidePage';
import { ChallengeLeaderboardPage } from '~/components/Challenge/Leaderboard/ChallengeLeaderboardPage';
import { ChallengePurchasePage } from '~/components/Challenge/Purchase/ChallengePurchasePage';
import { ChallengeScorePage } from '~/components/Challenge/Score/ChallengeScorePage';

export const ChallengeRouteSwitch = ({ match: { path, url }, location }: RouteComponentProps) => (
  <Route>
    <Switch>
      <Route path={path} exact component={ChallengeEventPage} />
      <Route path={`${path}/purchase`} exact component={ChallengePurchasePage} />
      <Route path={`${path}/score`} exact component={ChallengeScorePage} />
      <Route path={`${path}/leaderboard`} exact component={ChallengeLeaderboardPage} />
      <Route path={`${path}/guide`} exact component={ChallengeGuidePage} />
      <Redirect to={{ ...location, pathname: url }} />
    </Switch>
  </Route>
);
